
      import WechatLine from './wechat-line.vue'
      import type { App, Plugin } from 'vue'

      export const WechatLinePlugin: Plugin = {
        install(app: App) {
          app.component('WechatLine', WechatLine)
        },
      }
      export { WechatLine }
      